// fiuhb_frontend/src/services/finance_services/revenueService.js
import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const Finance_Base_Url = `${API_BASE_URL}/finances`;

// Revenue Category Services
export const getRevenueCategories = async (invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/revenues/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching revenue categories:', error);
    throw error;
  }
};

export const createRevenueCategory = async (categoryData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/revenues/create/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(categoryData),
    });
    return response;
  } catch (error) {
    console.error('Error creating revenue category:', error);
    throw error;
  }
};

export const getRevenueCategory = async (categoryId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/revenues/${categoryId}/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching revenue category:', error);
    throw error;
  }
};

export const updateRevenueCategory = async (categoryId, categoryData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/revenues/${categoryId}/update/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(categoryData),
    });
    return response;
  } catch (error) {
    console.error('Error updating revenue category:', error);
    throw error;
  }
};

export const deleteRevenueCategory = async (categoryId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/categories/revenues/${categoryId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting revenue category:', error);
    throw error;
  }
};

// Revenue Services
export const getRevenues = async (page = 1, pageSize = 10, filters = {}, invitationId = null) => {
  const params = new URLSearchParams({
    page: page.toString(),
    page_size: pageSize.toString()
  });
  
  // Add optional filter parameters
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.category) {
    params.append('category', filters.category);
  }
  if (filters.date_range) {
    params.append('date_range', filters.date_range);
  }
  if (filters.start_date) {
    params.append('start_date', filters.start_date);
  }
  if (filters.end_date) {
    params.append('end_date', filters.end_date);
  }
  if (filters.payment_method) {
    params.append('payment_method', filters.payment_method);
  }
  if (filters.reference_number) {
    params.append('reference_number', filters.reference_number);
  }
  
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching revenues:', error);
    throw error;
  }
};

export const createRevenue = async (revenueData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/create/?${params.toString()}`;
  console.log('Creating revenue with data:', revenueData);
  
  try {
    const response = await authenticatedRequest(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(revenueData),
    });
    console.log('Create revenue response:', response);
    return response;
  } catch (error) {
    console.error('Error creating revenue:', error);
    throw error;
  }
};

export const getRevenue = async (revenueId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/${revenueId}/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Error fetching revenue:', error);
    throw error;
  }
};

export const updateRevenue = async (revenueId, revenueData, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/${revenueId}/update/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(revenueData),
    });
    return response;
  } catch (error) {
    console.error('Error updating revenue:', error);
    throw error;
  }
};

export const deleteRevenue = async (revenueId, invitationId = null) => {
  const params = new URLSearchParams();
  if (invitationId) {
    params.append('invitation_id', invitationId);
  }
  
  const url = `${Finance_Base_Url}/revenues/${revenueId}/delete/?${params.toString()}`;
  try {
    const response = await authenticatedRequest(url, {
      method: 'DELETE',
    });
    return response;
  } catch (error) {
    console.error('Error deleting revenue:', error);
    throw error;
  }
};

